import React, { useContext } from "react";
import { Language, TText } from "api/type";
import { LanguageContext } from "contexts";

const text: TText = {
  text1: {
    en: "Please make sure your volume is turned on to hear the instructions.",
    es: "Asegúrese de que el volumen esté encendido para escuchar las instrucciones.",
  },
};

const Screen3: React.FC = () => {
  const language = useContext<Language>(LanguageContext)[0];

  if (!language) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "auto",
      }}
    >
      <img
        src="https://clinic-os.com/flow-assets%2Fbody-scan-instructions%2Fscan-instructions3.png"
        alt=""
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "322px",
          aspectRatio: "1",
        }}
      />
      <p
        style={{
          fontSize: "14px",
          color: "black",
          fontWeight: 400,
          width: "322px",
        }}
      >
        {text.text1[language]}
      </p>
    </div>
  );
};

export default Screen3;
